import { Component, Input } from '@angular/core';
import { Consultation } from '@app/core/models';
import { IconName } from '@app/shared/utils/icon/icons';
import { translateKey } from '@app/shared/utils/static-helpers/translate';
import { IconComponent } from '../../utils/icon/icon.component';
import { UpperCasePipe, DatePipe } from '@angular/common';

@Component({
  selector: 'app-renal-values',
  templateUrl: './renal-values.component.html',
  styleUrls: ['./renal-values.component.scss'],
  imports: [IconComponent, UpperCasePipe, DatePipe],
})
export class RenalValuesComponent {
  @Input() consultation: Consultation;
  date: string;
  creatinine = translateKey('label-blood-creatinine');
  urea = translateKey('label-blood-urea');
  urine = translateKey('label-gravity');
  IconName = IconName;
}
